const WP_THEME_PATH = "/wp-content/themes/mcdtkit";

const STYLESHEETS = [
	{ id: "wp-global-css", path: `${WP_THEME_PATH}/assets/css/global.css` },
	{ id: "wp-theme-css", path: `${WP_THEME_PATH}/style.css` },
	{ id: "wp-custom-css", path: `${WP_THEME_PATH}/custom.css` },
];

export function loadWordPressStyles(wpBaseUrl: string): void {
	const cacheBuster = `v=${Date.now()}`;
	const baseUrl = wpBaseUrl.replace(/\/+$/, "");

	for (const { id, path } of STYLESHEETS) {
		if (document.getElementById(id)) continue;

		const link = document.createElement("link");
		link.id = id;
		link.rel = "stylesheet";
		link.href = `${baseUrl}${path}?${cacheBuster}`;
		document.head.appendChild(link);
	}
}
